import { CalendarLandingPage } from 'client/cal/landing-page';

export function CalendarLandingPageApp() {
  const content = window.ruzukuGlobal?.landingPageContent;
  const isPublished = window.ruzukuGlobal?.isLandingPagePublished ?? true;
  return <CalendarLandingPage hostId={undefined} content={content} isPublished={isPublished} />;
}
